import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_TEM003_Request } from "../../type/apiType";
import { httpAPI_TEM003 } from "./api/request";
import { schema, tableList } from "./parts";
import TkDialog from "../../components/atoms/TkDialog";
import _ from "lodash";

/**
 * SCRW140002 テンプレート新規登録
 * 機構職員がメールテンプレートを新規登録する。
 * @return SCRW140002
 */
const SCRW140002 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const [stateTableList, setStateTableList] = useState(_.cloneDeep(tableList));
  const [open, setOpen] = useState(false);
  const [saveData, setSaveData] = useState<any>();

  // 初期表示
  useEffect(() => {
    let resArr = stateTableList;
    let emailClass = resArr.find((item) => item.keyword === "emailClass")!;

    // メール種別
    emailClass.setDefaultValue = location.state?.emailClass;

    setStateTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (obj: any): IAPI_TEM003_Request => {
    const reqObj: IAPI_TEM003_Request = {
      emailClass: obj.emailClass,
      tempName: obj.tempName,
      title: obj.title,
      text: obj.text,
      destinationTiming1: "4",
    };

    return reqObj;
  };

  const handleSubmit = (data: any) => {
    setSaveData(data);
    setOpen(true);
  };

  const onSave = async () => {
    setOpen(false);
    try {
      const res = await httpAPI_TEM003({
        ...makeHttpObj(saveData),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRW140001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRW140002">
      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        buttonGroup={<TkBackButton />}
        submitButtonGroup={[{ submitButtonText: "登録" }]}
        onCheckAndSubmit={handleSubmit}
      />
      <TkDialog
        title="確認（情報を登録します）"
        contextText="　入力した内容で登録を行いますが、問題ないでしょうか。"
        open={open}
        okText="はい"
        cancelText="いいえ"
        onSave={() => onSave()}
        onCancel={() => setOpen(false)}
      />
    </Box>
  );
};

export default SCRW140002;
